import axios from 'axios';
import { fromJS } from 'immutable';
import { MAPS, INFRASTRUCTURE, ANNOUNCEMENT_LOAD, TERRITORIAL_DIVISION } from './actionTypes';
import { MODAL_HIDE, MODAL_SHOW, START, SUCCESS, ERROR } from '../../consts';
import getInfrastructureItems from '../../utils/infrastructure';

import api from '../../apiSingleton';

/**
 * Показать модальное окно с картой
 * @param data
 * @returns {{type: *, payload: *}}
 */
export function showMapsModal (data) {
  return {
    type: MAPS + MODAL_SHOW,
    payload: data
  };
}

/**
 * Скрыть модальное окно с картой
 * @returns {{type: *}}
 */
export function hideMapsModal () {
  return {
    type: MAPS + MODAL_HIDE
  };
}

export function loadAnnouncement (dealType, realtyType, filter) {
  return dispatch => {
    dispatch({
      type: ANNOUNCEMENT_LOAD + START
    });

    return api.announcement.fetchAnnouncement(dealType, realtyType, filter)
      .then((data) => dispatch({
        type: ANNOUNCEMENT_LOAD + SUCCESS,
        items: fromJS(data.items.filter(item => item.lat && item.lon)),
        meta: fromJS(data._meta)
      }))
      .catch((err) => dispatch({
        type: ANNOUNCEMENT_LOAD + ERROR,
        payload: err.message
      }));
  };
}

/**
 * Загрузить инфраструктуру
 * lat ~ 55.000573
 * lon ~ 73.298359
 */
export function loadInfrastructure (realtyId, lon, lat, radius = 1000) {
  return (dispatch) => {
    dispatch({
      type: INFRASTRUCTURE + START,
      realtyId
    });

    const gisUrl = 'https://catalog.api.2gis.ru/2.0/catalog/branch/search?' +
                    `point=${lon},${lat}&radius=${radius}&version=2.0&key=rurbvg0067&fields=items.point&q=`;

    const categories = getInfrastructureItems();

    Promise.all(categories.map(category => axios.get(gisUrl + category.name)))
    .then((data) => {
      const state = {};

      data.map(function (resp, index) {
        const category = categories[index];
        const orgList = [];

        if (resp.data.result && resp.data.result.items) {
          resp.data.result.items.map(function (org, id) {
            orgList.push({
              id,
              name: org.name,
              point: org.point,
              distance: (org.context && org.context.distance) || null
            });
          });
        }

        if (orgList.length) {
          state[category.id] = {
            id: category.id,
            name: category.name,
            count: orgList.length,
            items: orgList
          };
        }
      });

      dispatch({
        type: INFRASTRUCTURE + SUCCESS,
        payload: fromJS(state)
      });
    }).catch((err) => dispatch({
      type: INFRASTRUCTURE + ERROR,
      payload: err.message
    }));
  };
}

export function showTerritorialDivisionModal () {
  return {
    type: TERRITORIAL_DIVISION + MODAL_SHOW
  };
}

export function hideTerritorialDivisionModal () {
  return {
    type: TERRITORIAL_DIVISION + MODAL_HIDE
  };
}



// WEBPACK FOOTER //
// ./src/app/Maps/actions.js